var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubstationPlanned({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3791_7569)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FF6673"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3791_7569)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.66699C18.3681 8.667 18.6668 8.96497 18.667 9.33301V10.667H20.667V10C20.667 9.63193 20.965 9.33319 21.333 9.33301C21.7012 9.33301 22 9.63181 22 10V10.667H23.333V10C23.333 9.63181 23.6318 9.33301 24 9.33301C24.3682 9.33302 24.667 9.63182 24.667 10V10.667L24.8008 10.6807C25.1045 10.7428 25.3329 11.0109 25.333 11.333C25.333 11.7011 25.035 11.9998 24.667 12H22.9424L18.667 16.2754V22.667C18.6668 23.035 18.3681 23.333 18 23.333C17.6319 23.333 17.3332 23.035 17.333 22.667V16.2754L13.0576 12H11.333C10.965 11.9998 10.667 11.7011 10.667 11.333C10.6671 11.0109 10.8955 10.7427 11.1992 10.6807L11.333 10.667V10C11.333 9.63182 11.6318 9.33301 12 9.33301C12.3682 9.33301 12.667 9.63181 12.667 10V10.667H14V10C14 9.63181 14.2988 9.33301 14.667 9.33301C15.035 9.33318 15.333 9.63192 15.333 10V10.667H17.333V9.33301C17.3332 8.96496 17.6319 8.66699 18 8.66699ZM17.333 14.3906V12H14.9424L17.333 14.3906ZM18.667 12V14.3906L21.0576 12H18.667Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3791_7569",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3791_7569"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3791_7569",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3791_7569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstationPlanned);
export default __webpack_public_path__ + "static/media/substation_planned.198723d6754101f200141f503617dbee.svg";
export { ForwardRef as ReactComponent };